import type { DisplayStatus } from "../lib/types";
import { STATUS_LABELS } from "../lib/format";

const STYLES: Record<DisplayStatus, string> = {
  entwurf: "bg-slate-100 text-slate-700",
  offen: "bg-blue-50 text-blue-700",
  teilbezahlt: "bg-amber-50 text-amber-700",
  ueberfaellig: "bg-red-50 text-red-700",
  bezahlt: "bg-emerald-50 text-emerald-700",
  storniert: "bg-slate-100 text-slate-500 line-through",
  abgeschrieben: "bg-slate-100 text-slate-500",
  stornorechnung: "bg-violet-50 text-violet-700",
};

export function StatusBadge({ status }: { status: DisplayStatus }) {
  return (
    <span
      className={`inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium whitespace-nowrap ${STYLES[status]}`}
    >
      {STATUS_LABELS[status]}
    </span>
  );
}
